import React, { useState } from "react";
import {
  Col,
  Modal,
  Row,
  ModalHeader,
  Label,
  Button,
  FormFeedback,
  Alert,
  Form,
  Input,
} from "reactstrap";

import PropTypes from "prop-types";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";

import { contactsCreate, contactsFulllist } from '../../../../store/contacts/actions';

import '../../../Precontacto/style/style.scss'
const ContactoAddModal = (props) => {
  const optionGroupTipoIdentificacion = [
    {
      options: [
        { label: "CEDULA", value: "CEDULA" },
        { label: "PASAPORTE", value: "PASAPORTE" },
        { label: "CEDULA DE EXTRANJERIA", value: "CEDULA_EXTRANJERIA" },
        { label: "NIT", value: "NIT" },
        { label: "OTRO", value: "OTRO" },
      ],
    },
  ];

  const [formData, setFormData] = useState({
    username: "",

    documentNumber: "",
    birthdate: "2000-01-01",
    city: "",
    razon_social: "",
    phone: "",
    address: "",
    barrio_localidad: "",
    cargo: "",
    persona_contacto: "",
    first_name: "",
    last_name: "",
    contactType: "",
    tipo_cliente: "",
  });

  const {
    username,
    razon_social,
    documentNumber,
    birthdate,
    city,
    phone,
    address,
    barrio_localidad,
    persona_contacto,
    cargo,
    first_name,
    last_name,
    contactType,
    tipo_cliente,
    documentType,
  } = formData;

  const onChange = (e) => {
    const uppercaseValue = e.target.value.toUpperCase();
    setFormData({ ...formData, [e.target.name]: uppercaseValue });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    props.contactsCreate({
      razon_social,
      username,

      documentType,
      documentNumber,
      birthdate,
      city,
      phone,
      address,
      barrio_localidad,
      tipo_cliente,
      cargo,
      persona_contacto,
      first_name,
      last_name,
      contactType,
    });
  };

  const handleButtonClick = () => {
    props.onCloseClick();
  };



  return (
    <React.Fragment>


{props.contactsCreated.id ? (
                <SweetAlert
                  title="Hecho!"
                  success
                  timeout={1000}
                  showConfirm={false}
                  onConfirm={() => {
                    handleButtonClick()
                    props.contactsFulllist()
                  }}
                >
                  Se ha agregado el Contacto
                </SweetAlert>
              ) : null}



      <Modal
        isOpen={props.crearModal}
        toggle={props.onCloseClick}
        centered={true}
      >
        <ModalHeader toggle={handleButtonClick} tag="h4">
          Crear Nuevo Contacto
        </ModalHeader>

        <Form onSubmit={onSubmit}
        style={{padding:'10px'}}
        >
          {/* Razon Social y telefono */}
          <Row>
            <Col lg={6} className="mb-3">
              <Label for="razon_social" className="form-label">
                Razon Social
              </Label>
              <Input
                id="razon_social"
                name="razon_social"
                type="text"
                onChange={onChange}
               
                value={razon_social}
                valid={
                  props.error.razon_social
                    ? true
                    : props.contactsCreated && false
                }
                invalid={
                  props.error
                    ? props.error.razon_social
                      ? true
                      : false
                    : false
                }
              />

              <FormFeedback>{props.error.razon_social}</FormFeedback>
            </Col>

            <Col lg={6} className="mb-3">
              <Label for="phone" className="form-label">
                Telefono y/o celular
              </Label>
              <Input
                id="phone"
                name="phone"
                type="text"
                onChange={onChange}
           
                valid={
                  props.error.phone ? true : props.contactsCreated && false
                }
                invalid={
                  props.error ? (props.error.phone ? true : false) : false
                }
              />

              <FormFeedback>{props.error.phone}</FormFeedback>
            </Col>
          </Row>

          {/* Nombres y Apellidos */}
          <Row>
            <Col lg={6} className="mb-3">
              <Label for="first_name" className="form-label">
                Nombres
              </Label>
              <Input
                id="first_name"
                name="first_name"
                type="text"
                onChange={onChange}

                value={first_name}
              />
            </Col>
            <Col lg={6} className="mb-3">
              <Label for="apellido" className="form-label">
                Apellidos
              </Label>
              <Input
                id="last_name"
                name="last_name"
                type="text"
                onChange={onChange}
            
                value={last_name}
              />
              <FormFeedback>{props.error.last_name}</FormFeedback>
            </Col>
          </Row>

          {/* Persona contacto y Cargo */}
          <Row>
            <Col lg={6} className="mb-3">
              <Label for="persona_contacto" className="form-label">
                Persona Contacto
              </Label>
              <Input
                id="persona_contacto"
                name="persona_contacto"
                type="text"
                onChange={onChange}
             
                value={persona_contacto}
                valid={
                  props.error.persona_contacto
                    ? true
                    : props.contactsCreated && false
                }
                invalid={
                  props.error
                    ? props.error.persona_contacto
                      ? true
                      : false
                    : false
                }
              />
              <FormFeedback>{props.error.persona_contacto}</FormFeedback>
            </Col>
            <Col lg={6} className="mb-3">
              <Label for="cargo" className="form-label">
                Cargo
              </Label>
              <Input
                id="cargo"
                name="cargo"
                type="text"
                onChange={onChange}
             
                value={cargo}
                valid={
                  props.error.cargo ? true : props.contactsCreated && false
                }
                invalid={
                  props.error ? (props.error.cargo ? true : false) : false
                }
              />
              <FormFeedback>{props.error.cargo}</FormFeedback>
            </Col>
          </Row>

          {/* tipo de Contacto y tipo de identificacion */}
          <Row>
            <Col lg={6} className="mb-3">
              <Label for="contactType" className="form-label">
                Tipo de Contacto
              </Label>

              <select
                className="form-select"
                id="contactType"
                name="contactType"
              
                value={contactType}
                onChange={onChange}
              >
                <option defaultValue="">Seleccione</option>
                <option value="PERSONA NATURAL">PERSONA NATURAL</option>
                <option value="PERSONA JURIDICA">PERSONA JURIDICA</option>

                <option value="OTRO">OTRO</option>
              </select>

              {props.error && props.error.contactType ? (
                <Alert color="danger" className="mt-2">
                  {props.error.contactType}
                </Alert>
              ) : null}
            </Col>

            <Col lg={6} className="mb-3">
              <Label for="contactType" className="form-label">
                Tipo de identificación
              </Label>
              <select
                className="form-select"
                id="documentType"
                name="documentType"
               
                value={documentType}
                onChange={onChange}
              >
                <option value="">Seleccione</option>

                {Array.isArray(optionGroupTipoIdentificacion)
                  ? optionGroupTipoIdentificacion[0].options.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))
                  : []}
              </select>
            </Col>
          </Row>

          {/* Documento y CIudad */}
          <Row>
            <Col lg={6} className="mb-3">
              <Label for="documento" className="form-label">
                Documento
              </Label>
              <Input
                id="documentNumber"
                name="documentNumber"
                type="number"
                onChange={onChange}
             
                value={documentNumber}
                valid={
                  props.error.documentNumber
                    ? true
                    : props.contactsCreated && false
                }
                invalid={
                  props.error
                    ? props.error.documentNumber
                      ? true
                      : false
                    : false
                }
              />
              <FormFeedback>{props.error.documentNumber}</FormFeedback>
            </Col>

            <Col lg={6} className="mb-3">
              <Label for="city" className="form-label">
                Ciudad
              </Label>
              <Input
                id="city"
                name="city"
                type="text"
                onChange={onChange}
       
                value={city}
                valid={props.error.city ? true : props.contactsCreated && false}
                invalid={
                  props.error ? (props.error.city ? true : false) : false
                }
              />
              <FormFeedback>{props.error.city}</FormFeedback>
            </Col>
          </Row>

          {/* Direaccion  y Barrio o Localidad */}
          <Row>
            <Col lg={6} className="mb-3">
              <Label for="address" className="form-label">
                Direccion
              </Label>
              <Input
                id="address"
                name="address"
                type="text"
                onChange={onChange}
      
                value={address}
                valid={
                  props.error.address ? true : props.contactsCreated && false
                }
                invalid={
                  props.error ? (props.error.address ? true : false) : false
                }
              />
              <FormFeedback>{props.error.address}</FormFeedback>
            </Col>

            <Col lg={6} className="mb-3">
              <Label for="barrio_localidad" className="form-label">
                Barrio o Localidad
              </Label>
              <Input
                id="barrio_localidad"
                name="barrio_localidad"
                type="text"
                onChange={onChange}
           
                value={barrio_localidad}
                valid={
                  props.error.barrio_localidad
                    ? true
                    : props.contactsCreated && false
                }
                invalid={
                  props.error
                    ? props.error.barrio_localidad
                      ? true
                      : false
                    : false
                }
              />
              <FormFeedback>{props.error.city}</FormFeedback>
            </Col>
          </Row>

          {/* tipo de Clientey Correo*/}
          <Row>
            <Col lg={6} className="mb-3">
              <Label for="tipo_cliente" className="form-label">
                Tipo de Contacto
              </Label>

              <select
                className="form-select"
                id="tipo_cliente"
                name="tipo_cliente"
          
                value={tipo_cliente}
                onChange={onChange}
              >
                <option defaultValue="Seleccione">Seleccione</option>
                <option value="CLIENTE ANTIGUO">CLIENTE ANTIGUO</option>
                <option value="CLIENTE NUEVO">CLIENTE NUEVO</option>
              </select>

              {props.error && props.error.tipo_cliente ? (
                <Alert color="danger" className="mt-2">
                  {props.error.tipo_cliente}
                </Alert>
              ) : null}
            </Col>

            <Col lg={6} className="mb-3">
              <Label for="username" className="form-label">
                Correo Electrónico
              </Label>
              <Input
                id="username"
                name="username"
                type="text"
                placeholder="example@xxxx.com"
                onChange={onChange}
    
                value={username}
                valid={
                  props.error.username ? true : props.contactsCreated && false
                }
                invalid={
                  props.error ? (props.error.username ? true : false) : false
                }
              />
              <FormFeedback>{props.error.username}</FormFeedback>
            </Col>
          </Row>

          <Row className="col-lg-12 justify-content-center">
            <Col md={1} className="mx-1">
              <Button color="primary" type="submit">
                Enviar
              </Button>
            </Col>
            <Col md={1} className="mx-1">
              <button
                className="btn btn-secondary btn-volver"
                type="button"
                onClick={handleButtonClick}
              >
                Volver
              </button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

 
const mapStateToProps = (state) => {
    const { error, loading, contactsCreated } = state.Contacts;
    return { error, loading, contactsCreated};
  };
  
  ContactoAddModal.propTypes = {
    error: PropTypes.any,
    loading: PropTypes.bool,
    contactsCreated: PropTypes.object,
  };
  export default withRouter(connect(mapStateToProps, { contactsCreate, contactsFulllist })(ContactoAddModal));
  

